import { useIntl } from 'react-intl';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { DropdownContent } from '@/patterns/global-nav/src/dropdown-content.tsx';
import { GlobalNav } from '@/patterns/global-nav/src/nav-global';
import { CompoundSubNavProps } from '@/patterns/global-nav/src/nav-global-compound-subnav';

export const CollectionsCompoundNav = () => {
	const intl = useIntl();

	const teamworkOverviewHref = useLocalizedHref('/collections/teamwork');
	const teamworkFeaturesHref = useLocalizedHref('/collections/teamwork/features');
	const teamworkEnterpriseHref = useLocalizedHref('/collections/teamwork/enterprise');
	const teamworkPricingHref = useLocalizedHref('/collections/teamwork/pricing');
	const teamworkResourcesHref = useLocalizedHref('/collections/teamwork/resources');

	const strategyOverviewHref = useLocalizedHref('/collections/strategy');
	const strategyDemosHref = useLocalizedHref('/collections/strategy/demo-center');
	const strategyPricingHref = useLocalizedHref('/collections/strategy/pricing');
	const strategyResourcesHref = useLocalizedHref('/collections/strategy/resources');
	const strategyUseCasesHref = useLocalizedHref('/collections/strategy/use-cases');
	const strategyCustomersHref = useLocalizedHref('/collections/strategy/customers');

	const serviceOverviewHref = useLocalizedHref('/collections/service');
	const servicePricingHref = useLocalizedHref('/collections/service/pricing');

	const softwareHref = useLocalizedHref('/collections/software');

	const productHref = useLocalizedHref('/collections/product');

	const collectionsHref = useLocalizedHref('/collections');

	const props: CompoundSubNavProps = {
		optionalClassName: 'collections-nav',
		compoundSubNavTitle: 'Collections',
		compoundSubNavTitleHref: collectionsHref,
		compoundSubNavLinksProps: [
			{
				globalLinksKey: 'teamwork',
				linkText: 'Teamwork',
				hasSubnav: true,
				content: (
					<DropdownContent
						orientation="column"
						contentSections={[
							{
								links: [
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.overview',
											defaultMessage: 'Overview',
										}),
										href: teamworkOverviewHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.features',
											defaultMessage: 'Features',
										}),
										href: teamworkFeaturesHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.enterprise',
											defaultMessage: 'Enterprise',
										}),
										href: teamworkEnterpriseHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.pricing',
											defaultMessage: 'Pricing',
										}),
										href: teamworkPricingHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.resources',
											defaultMessage: 'Resources',
										}),
										href: teamworkResourcesHref,
									},
								],
							},
						]}
					/>
				),
			},
			{
				globalLinksKey: 'strategy',
				linkText: 'Strategy',
				hasSubnav: true,
				content: (
					<DropdownContent
						orientation="column"
						contentSections={[
							{
								links: [
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.overview',
											defaultMessage: 'Overview',
										}),
										href: strategyOverviewHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.demos',
											defaultMessage: 'Demos',
										}),
										href: strategyDemosHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.pricing',
											defaultMessage: 'Pricing',
										}),
										href: strategyPricingHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.resources',
											defaultMessage: 'Resources',
										}),
										href: strategyResourcesHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.useCases',
											defaultMessage: 'Use Cases',
										}),
										href: strategyUseCasesHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.customers',
											defaultMessage: 'Customers',
										}),
										href: strategyCustomersHref,
									},
								],
							},
						]}
					/>
				),
			},
			{
				globalLinksKey: 'service',
				linkText: 'Service',
				hasSubnav: true,
				content: (
					<DropdownContent
						orientation="column"
						contentSections={[
							{
								links: [
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.overview',
											defaultMessage: 'Overview',
										}),
										href: serviceOverviewHref,
									},
									{
										text: intl.formatMessage({
											id: 'CollectionsCompoundSubNavProps.pricing',
											defaultMessage: 'Pricing',
										}),
										href: servicePricingHref,
									},
								],
							},
						]}
					/>
				),
			},
			{
				globalLinksKey: 'software',
				linkText: 'Software',
				hasSubnav: false,
				href: softwareHref,
			},
			{
				globalLinksKey: 'product',
				linkText: 'Product',
				hasSubnav: false,
				href: productHref,
			},
		],
		isShowCta: false,
	};

	return <GlobalNav productKey={'collection'} compoundNav={props} />;
};
